import { Grid, Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { lightPalette } from '../../../theme';
import { getImportExportDocuments } from '../../../services/adminDashboard';

const TotalDocumentCard = ({
  cartTitle,
  totalDocuments,
  lastWeekDocuments,
  backgroundColor,
}) => (
  <Grid
    item
    xs={12}
    backgroundColor={backgroundColor}
    sx={{
      height: '49%',
      borderRadius: '10px',
    }}
  >
    <Box
      sx={{
        height: '100%',
        padding: '20px',
      }}
    >
      <Box sx={{ height: '70%' }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 400,
            color: lightPalette.deepAmethyst.semiDark,
          }}
        >
          {cartTitle || ''}
        </Typography>
        <Typography
          sx={{
            fontSize: '36px !important',
            fontWeight: 500,
            color: lightPalette.darkPurple.main,
          }}
        >
          {totalDocuments || 0}
        </Typography>
      </Box>
      <Box
        sx={{
          height: '30%',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            color: lightPalette.deepAmethyst.semiDark,
          }}
        >
          Since last week
        </Typography>
        <Typography
          sx={{
            fontSize: '24px !important',
            fontWeight: 500,
            color: lightPalette.darkPurple.main,
            marginLeft: '10px',
          }}
        >
          {lastWeekDocuments || 0}
        </Typography>
      </Box>
    </Box>
  </Grid>
);

TotalDocumentCard.propTypes = {
  cartTitle: PropTypes.string.isRequired,
  totalDocuments: PropTypes.number.isRequired,
  lastWeekDocuments: PropTypes.number.isRequired,
  backgroundColor: PropTypes.string.isRequired,
};

const TotalDocumentCardGrid = ({
  itemName,
  selectedDashboardType,
  filteredTypes,
  getTypeByTitle,
}) => {
  const [totalCardData, setTotalCardData] = useState({
    totalImport: 0,
    totalExport: 0,
    lastWeekImport: 0,
    lastWeekExport: 0,
  });

  const getTotalDocumentsData = async () => {
    const typePayloadArr =
      selectedDashboardType === 'compare'
        ? getTypeByTitle(itemName)
        : filteredTypes;

    const response = await getImportExportDocuments(typePayloadArr);
    if (response && Object.keys(response?.data?.stages)?.length > 0) {
      const finalData = response.data.stages;
      setTotalCardData({
        totalImport: finalData?.importResult?.totalImport || 0,
        totalExport: finalData?.exportResult?.totalExport || 0,
        lastWeekImport: finalData?.importResult?.lastWeekImport || 0,
        lastWeekExport: finalData?.exportResult?.lastWeekExport || 0,
      });
    } else {
      setTotalCardData({});
    }
  };

  useEffect(() => {
    getTotalDocumentsData();
  }, [filteredTypes]);
  return (
    <>
      <TotalDocumentCard
        cartTitle="Import Document"
        totalDocuments={totalCardData?.totalImport}
        lastWeekDocuments={totalCardData?.lastWeekImport}
        backgroundColor={lightPalette.secondaryWhite.main}
      />
      <TotalDocumentCard
        cartTitle="Export Document"
        totalDocuments={totalCardData?.lastWeekExport}
        lastWeekDocuments={totalCardData?.lastWeekExport}
        backgroundColor={lightPalette.secondaryWhite.main}
      />
    </>
  );
};

TotalDocumentCardGrid.defaultProps = {
  itemName: '',
  filteredTypes: [],
  getTypeByTitle: null,
};

TotalDocumentCardGrid.propTypes = {
  itemName: PropTypes.string,
  selectedDashboardType: PropTypes.string.isRequired,
  filteredTypes: PropTypes.arrayOf(),
  getTypeByTitle: PropTypes.func,
};

export default TotalDocumentCardGrid;
